import registerChangeKeyboardLanguageDirective from './ChangeKeyboardLanguageDirective';
import ChangeKeyboardLanguageDirectiveController from './ChangeKeyboardLanguageDirectiveController';

export default function registerChangeKeyboardLanguage(angular) {
    registerChangeKeyboardLanguageDirective(angular.module('assessmentFrontendDirectives'));
    angular.module('assessmentFrontendControllers').controller('ChangeKeyboardLanguageDirectiveController', ['$scope', '$route', '$injector', ChangeKeyboardLanguageDirectiveController]);
}